import React from "react";


const ErrorView = () => {
  return (
    <div>
      somting went wrong
    </div>
  );
};

export default ErrorView;